import { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { ShieldAlert, Wifi, Users } from "lucide-react";

const GUARDS = [
  { key: "block_vpn", label: "Block VPN / Proxy", icon: Wifi, desc: "Stops anyone verifying through a VPN, proxy or data-centre IP." },
  { key: "block_alts", label: "Alt Account Detection", icon: Users, desc: "Stops a second account verifying from an IP another member already used." },
];

export const VerifyGuards = ({ guildId, cfg, onSave, busy }) => {
  const [blocks, setBlocks] = useState([]);
  useEffect(() => {
    api.get(`/guilds/${guildId}/verify-blocks`).then(r => setBlocks(r.data.items || [])).catch(() => {});
  }, [guildId]);

  return (
    <div className="border border-white/10 bg-[#0D0E15] p-5 space-y-4" data-testid="verify-guards-panel">
      <div className="flex items-center gap-2">
        <ShieldAlert className="w-4 h-4 text-[#EF4444]" />
        <span className="font-mono text-[10px] tracking-widest text-[#94A3B8] uppercase">Verification Guards · Free</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {GUARDS.map(g => {
          const on = !!cfg?.[g.key];
          return (
            <button
              key={g.key}
              data-testid={`verify-guard-${g.key}`}
              disabled={busy}
              onClick={() => onSave({ [g.key]: !on })}
              className={`text-left border p-4 transition-colors duration-200 ${on ? "border-[#10B981] bg-[#10B981]/10" : "border-white/10 bg-[#06070A] hover:border-white/30"}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <g.icon className={`w-4 h-4 ${on ? "text-[#10B981]" : "text-[#64748B]"}`} />
                <span className="font-medium text-sm text-white">{g.label}</span>
                <span data-testid={`verify-guard-${g.key}-state`} className={`ml-auto font-mono text-[10px] tracking-widest ${on ? "text-[#10B981]" : "text-[#64748B]"}`}>{on ? "ON" : "OFF"}</span>
              </div>
              <div className="text-xs text-[#94A3B8]">{g.desc}</div>
            </button>
          );
        })}
      </div>
      <div>
        <div className="font-mono text-[10px] tracking-widest text-[#64748B] uppercase mb-2">Recent blocked attempts · {blocks.length}</div>
        {blocks.length === 0 ? (
          <div className="font-mono text-xs text-[#64748B]" data-testid="verify-blocks-empty">// No blocked verifications yet.</div>
        ) : (
          <div className="space-y-1 max-h-48 overflow-y-auto" data-testid="verify-blocks-list">
            {blocks.map(b => (
              <div key={b.id} className="flex items-center gap-2 text-xs border-b border-white/5 py-1">
                <span className={`font-mono text-[10px] px-1.5 ${b.reason === "vpn" ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-[#EF4444]/20 text-[#EF4444]"}`}>{b.reason.toUpperCase()}</span>
                <span className="text-white truncate">{b.username}</span>
                <span className="text-[#64748B] truncate">{b.detail}</span>
                <span className="ml-auto font-mono text-[10px] text-[#64748B] whitespace-nowrap">{new Date(b.created_at).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
